import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { PlatformService } from '@panamax/app-state';
import { ShortPayCodes } from '@payments/constants/short-pay-codes.enum';

@Component({
  selector: 'app-short-pay-modal',
  templateUrl: './short-pay-modal.component.html',
  styleUrls: ['./short-pay-modal.component.scss'],
})
export class ShortPayModalComponent {
  optionsShortPay: any[];
  constructor(
    private modalController: ModalController,
    public platformService: PlatformService,
    translate: TranslateService,
  ) {
    this.optionsShortPay = [
      {
        id: ShortPayCodes.productDeliveryVariance,
        description: translate.instant(
          'i18n.payments.shortPayModal.productDeliveryVariance',
        ),
        dataCy: 'product-delivery-variance',
        selected: false,
      },
      {
        id: ShortPayCodes.partialPayment,
        description: translate.instant(
          'i18n.payments.shortPayModal.partialPayment',
        ),
        dataCy: 'partial-payment',
        selected: false,
      },
      {
        id: ShortPayCodes.productPricingVariance,
        description: translate.instant(
          'i18n.payments.shortPayModal.productPricingVariance',
        ),
        dataCy: 'product-pricing-variance',

        selected: false,
      },
      {
        id: ShortPayCodes.salesTaxVariance,
        description: translate.instant(
          'i18n.payments.shortPayModal.salesTaxVariance',
        ),
        dataCy: 'sales-tax-variance',
        selected: false,
      },
      {
        id: ShortPayCodes.other,
        description: translate.instant('i18n.payments.shortPayModal.other'),
        dataCy: 'other',
        selected: false,
      },
    ];
  }

  async closeModal() {
    await this.modalController.dismiss();
  }

  async submitShortPayModal() {
    await this.modalController.dismiss({
      shortPayCode: this.optionsShortPay.find(option => option.selected).id,
    });
  }

  deselectedOptions(option) {
    this.optionsShortPay.forEach(
      optionShortPay =>
        (optionShortPay.selected = optionShortPay.id === option.id),
    );
  }

  get isSomeOptionSelected() {
    return this.optionsShortPay.some(option => option.selected);
  }
}
